import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { ReviewsTable } from "./reviews-table";

export const InProgressTab: FC = () => (
  <>
    <Stack spacing={2} sx={{ mb: 4 }}>
      <Typography variant="body2">
        You’ve been asked to review the Communications below. You can comment and set approval
        status until the creator either publishes the Communication, or cancels the review.
      </Typography>
      <Typography variant="body2">
        When viewing a Communication, you can leave comments and set an approval status - either
        “Approved” or “Changes requested”. The original creator will be notified of each comment and
        status change.
      </Typography>
    </Stack>
    <ReviewsTable variant="in-progress" />
  </>
);
